function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.65039 25.2266H16.834V26.9844H3.65039V25.2266Z",
  fill: "#23335B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.65039 21.7109H16.834V23.4688H3.65039V21.7109Z",
  fill: "#23335B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.65039 18.1953H16.834V19.9531H3.65039V18.1953Z",
  fill: "#23335B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.8652 0.5H3.65039V4.01562H0.134766V30.5H20.3496V26.9844H23.8652V0.5ZM18.5918 28.7422H1.89258V5.77344H6.72656C8.18045 5.77344 9.36328 6.95627 9.36328 8.41016V15.002H15.9551C17.409 15.002 18.5918 16.1848 18.5918 17.6387V28.7422ZM15.2895 13.2441H11.1211V9.07578L15.2895 13.2441ZM22.1074 25.2266H20.3496V17.6387C20.3496 16.4271 19.8568 15.3285 19.061 14.5327C19.0625 14.5313 9.83397 5.30275 9.83397 5.30275C9.03674 4.50846 7.93811 4.01562 6.72656 4.01562H5.4082V2.25781H22.1074V25.2266Z",
  fill: "#23335B"
});

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.0f68e856.svg";
export { ForwardRef as ReactComponent };